import { connect } from 'react-redux'
import OrganisationFilesEntry from './organisation-files-entry'
import { getOrganisationFile } from '../../../../../../stores/organisation-files/organisation-files.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const organisationFile = getOrganisationFile(state, id)
  return {
    id: organisationFile.id,
    title: organisationFile.title,
    createdAt: format(organisationFile.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${organisationFile.id}`,
    conclusion: organisationFile.concluded,
    benchmarked: organisationFile.benchmarked,
    student:
      organisationFile.student_type &&
      organisationFile.student_type.first_name +
        ' ' +
        organisationFile.student_type.last_name,
    thumb:
      organisationFile.works &&
      organisationFile.works[0] &&
      organisationFile.works[0].media &&
      organisationFile.works[0].media[0] &&
      organisationFile.works[0].media[0].thumb_url,
    author:
      organisationFile.teacher_type && organisationFile.teacher_type.full_name
  }
}

export default connect(
  mapStateToProps,
  null
)(OrganisationFilesEntry)
